"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shimmer = exports.VideoSectionHeader = exports.VideoWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.VideoWrapper = styled_1.default.div `
  @media print {
    display: none;
  }
`;
exports.VideoSectionHeader = styled_1.default.h2 `
  margin: 0;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
`;
exports.Shimmer = (0, styled_1.default)(`div`) `
  border-radius: 2px;
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
  background: linear-gradient(
    to right,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 10%,
    ${(0, ui_theme_1.fromTheme)('color_background_disabled_form_input')} 18%,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 33%
  );
  background-size: 1000px 640px;
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
`;
//# sourceMappingURL=provider-video.styles.js.map